export const microAddress = 'https://micro.gruzbag.krzysztofsikorski.pl'